const contact = {
  title: "Contact Info",
  subtitle: "Share your contact person information to proceed.",
  name: {
    label: "Contact Name",
    placeholder: "Enter contact name",
  },
  phone: {
    label: "Phone Number",
    placeholder: "+966 (5) 0000-0000",
  },
  email: {
    label: "Email Address",
    placeholder: "useremail@example.com",
  },
  password: {
    label: "Password",
    placeholder: "Enter password",
  },
  confirmPassword: {
    label: "Confirm Password",
    placeholder: "Confirm password",
  },
  passwordRules: {
    minLength: "Must be at least 8 characters long.",
    complexity:
      "Includes one upper-case, one lower-case, and one special character.",
  },
  terms: {
    title: "Yoram's Terms & Conditions",
    confirmation:
      "By checking this box, I confirm that I've read & agree to the ",
    link: "Terms & Conditions",
    checkboxAria: "Accept terms and conditions",
  },
  actions: {
    next: "Next",
  },
};

export default contact;
